import { render, staticRenderFns } from "./PosterForm.vue?vue&type=template&id=b6a4d23c&scoped=true&"
import script from "./PosterForm.vue?vue&type=script&lang=js&"
export * from "./PosterForm.vue?vue&type=script&lang=js&"
import style0 from "./PosterForm.vue?vue&type=style&index=0&id=b6a4d23c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a4d23c",
  null
  
)

export default component.exports